import React, { useState } from "react";
import { Modal, Button } from "react-bootstrap"
import ImportErrorDetails from "./ImportErrorDetails";

interface ImportErrorDetailsProps {
  show: boolean
  importJobID: number
  pageSize: number
  onClose?: () => void
}

const ImportErrorDetailsModal = (props: ImportErrorDetailsProps) => {
  const [show, setShow] = useState(props.show)

  const handleClose = () => {
    props.onClose?.()
    setShow(false)
  }

  return (
    <Modal backdrop="static" centered show={show} onHide={() => handleClose()} dialogClassName="modal-90w" size="xl">
      <Modal.Header closeButton>
        <Modal.Title className="text-uppercase text-danger">Import errors:</Modal.Title>
      </Modal.Header>
      <Modal.Body className="pt-3">
        <ImportErrorDetails {...props} />
      </Modal.Body>
      <Modal.Footer>
        <Button variant="primary" onClick={() => handleClose()}>CLOSE</Button>
      </Modal.Footer>
    </Modal>
  )
}

export default ImportErrorDetailsModal;
